import React, { useState } from "react";
import { Col, Row, Button } from "reactstrap";
import DayPicker from "../components/DayPicker";
import Layout from "../components/Layout";
import UpcomingEvents from '../components/UpcomingEvents';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Upcoming = () => {
    const today = new Date();

    const getStartOfWeek = (date) => {
        const start = new Date(date);
        start.setDate(date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1));
        return start;
    };

    const [selectedDate, setSelectedDate] = useState(today);
    const [startDate, setStartDate] = useState(getStartOfWeek(today));

    const handleToday = () => {
        const newToday = new Date();
        const startOfWeek = getStartOfWeek(newToday);
        setStartDate(startOfWeek);
        setSelectedDate(newToday);
    };

    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
    };

    const nextWeekClick = () => {
        const nextWeek = new Date(startDate);
        nextWeek.setDate(nextWeek.getDate() + 7);
        setStartDate(nextWeek);
        setSelectedDate(nextWeek);
        handleDateChange(nextWeek);
    };

    const prevWeekClick = () => {
        const prevWeek = new Date(startDate);
        prevWeek.setDate(prevWeek.getDate() - 7);
        setStartDate(prevWeek);
        setSelectedDate(prevWeek);
        handleDateChange(prevWeek);
    };

    return (
        <Layout>
            <Row className="m-0 h-100 d-flex flex-column">
                <Col className="d-flex flex-column h-100">
                    <Row className="justify-content-center bg-white p-2 border-bottom">
                        <Col xs="1" className="d-flex justify-content-start m-0 p-0">
                            <Button color="secondary" onClick={prevWeekClick}>
                                <FaChevronLeft />
                            </Button>
                        </Col>
                        <Col xs="10" className="d-flex justify-content-center m-0 p-0">
                            <DayPicker
                                key={startDate}
                                startDate={startDate}
                                dateSelected={selectedDate}
                                onDateSelected={handleDateChange}
                                onToday={handleToday}
                            />
                        </Col>
                        <Col xs="1" className="d-flex justify-content-end m-0 p-0">
                            <Button color="secondary" onClick={nextWeekClick}>
                                <FaChevronRight />
                            </Button>
                        </Col>
                    </Row>
                    <Row className="border-start flex-grow-1 bg-dark bg-opacity-10">
                        <UpcomingEvents
                            key={selectedDate.toISOString()}
                            selectedDate={selectedDate}
                            onSubmit={handleDateChange}
                            onToday={handleToday}
                            gridSize={4}
                            bufferMins={240}
                            showToday={true}
                        />
                    </Row>
                </Col>
            </Row>
        </Layout>
    );
};

export default Upcoming;
